module.exports = __webpack_public_path__ + "img/help_dataset_estimate_small.b8f38217.png";